export default {
    data() {
        return {
            // 是否为VIP
            cpsVip: false,
        }
    },
    methods: {
        // 判断用户是否为大客户
        async getUserIfVip(params) {
            await Ajax.get('/api/usercenter/describeBaseInfo', params)
            .then((res) => {
                const meta = JSON.parse(res.data.meta);
                this.cpsVip = (meta && meta.cps_vip) === "1";
            }) 
        },
    }
}




// WEBPACK FOOTER //
// ./src/mixins/ifVip.js